module.exports = __webpack_public_path__ + "img/Practical Fixer.b9c25706.png";